export function GetBooleanFromString(strBool: string): boolean | string {
  switch (strBool) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return strBool;
  }
}
